import React from 'react';
import { useParams } from 'react-router-dom';
import { TripMatch } from '@marageti/z4-sdk/lib/travel';
import { useApiClient, useFetch } from '@marageti/z4-lib';
import MessagesView from './messages-view';

const MessagesContainer = () => {
  const { tripMatchId } = useParams();
  const apiClient = useApiClient();
  const tripMatch = useFetch<TripMatch>(apiClient.tripMatchesClient.getTripMatch, [tripMatchId], !!tripMatchId);

  if (!tripMatch.data) {
    return null;
  }

  return (
    <MessagesView
      travelerId={tripMatch.data.travelers?.[0]?.id}
      tripMatchId={tripMatchId}
    />
  );
};

export default MessagesContainer;
